<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Edit Reward</h4>
      </div>
      <div class="modal-body">
        <div class="row mb-3">
          <div class="col-sm-12">
            <label>Currency Type</label>
            <select class="form-control" [(ngModel)]="currencyType">
              @for (t of currencyTypes; track t[1]) {
                <option [ngValue]="t[1]">{{ t[0] }}</option>
              }
            </select>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-6">
            <label>Currency Quantity</label>
            <input class="form-control" [(ngModel)]="currencyQuantity" type="number" min="0">
          </div>
          <div class="col-sm-6">
            <label>Ticket Cost</label>
            <input class="form-control" [(ngModel)]="currencyTicketCost" type="number" min="0">
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button [disabled]="isLoading" type="button" class="btn btn-secondary" (click)="modal.hide()">Cancel</button>
        <button [disabled]="isLoading" type="button" class="btn btn-primary" (click)="save()">
          @if (isLoading) { <span class="spinner-border spinner-border-sm me-1"></span> }
          Save
        </button>
      </div>
    </div>
  </div>
</div>
